import React, {useContext, useMemo} from "react";
import {WhatsAppOutlined, MailOutlined, PhoneOutlined} from "@ant-design/icons";
import {Dropdown} from "antd";
import {AppContext} from "../AppContext.jsx";
import {getLogger} from "../Logger.jsx";
import {ContactPhone} from "../support/ContactPhone.jsx";
import {Config, ConfigProps} from "../Config.js";
import {ResponsiveView} from "../components/index.jsx";
import {Devices} from "../components/ResponsiveView/consts.js";
import {getThemeByOrigin} from "../utils.js";

const ContactMenu = ({style}) => {
    const {me, isMobile, company} = useContext(AppContext);

    const log = useMemo(() => getLogger({}, "ContactMenu"), []);

    const items = useMemo(() => {
        try {
            const assignedCSM = me?.assignedCSMs?.[0] || company?.assignedCSMs?.[0];
            const appContactDetailsBySystem = Config.envJson(ConfigProps.APP_CONTACT_DETAILS_BY_SYSTEM_ID);
            const appContactDetails = appContactDetailsBySystem[getThemeByOrigin(window.location.origin)];
            const whatsappNumber = appContactDetails?.whatsapp || assignedCSM?.phone;
            const phoneNumber =
                appContactDetails?.phone || assignedCSM?.phone || ContactPhone.defaultPhoneNumberBySystemId();

            const email = appContactDetails?.email || assignedCSM?.email;
            return [
                {
                    key: "whatsapp",
                    icon: (
                        <WhatsAppOutlined
                            style={{color: "#25D366", fontSize: "16px"}}
                            className="app-menu-menu-item-icon"
                        />
                    ),
                    label: `${ContactPhone.prettyPhoneNumber(whatsappNumber)}`,
                    onClick: () => ContactPhone.openWhatsApp(ContactPhone.prettyPhoneNumber(whatsappNumber))
                },
                {
                    key: "phone",
                    icon: (
                        <PhoneOutlined
                            style={{color: "#797EFF", fontSize: "16px"}}
                            className="app-menu-menu-item-icon"
                        />
                    ),
                    label: `${phoneNumber}`,
                    onClick: () => ContactPhone.openPhone(phoneNumber)
                },
                {
                    key: "mail",
                    icon: (
                        <MailOutlined
                            style={{color: "#F44336", fontSize: "16px"}}
                            className="app-menu-menu-item-icon"
                        />
                    ),
                    label: `${email}`,
                    onClick: () => ContactPhone.openEmail(email)
                }
            ];
        } catch (e) {
            console.error(e);
            return [];
        }
    }, [me?.assignedCSMs, company?.assignedCSMs]);

    const overlay = {
        items,
        className: "wb-contact-menu",
        style: {border: "1px solid #E8EDF5"},
        onClick: ({key}) => {
            log("Contact Menu Item Clicked", {itemName: key});
        }
    };

    return (
        <div
            style={{
                display: "flex",
                zIndex: 100,
                ...style
            }}>
            <Dropdown
                trigger={isMobile ? ["click"] : ["hover"]}
                onOpenChange={visible => {
                    log("menu visible", {visible});
                }}
                placement="bottomRight"
                overlayClassName="wb-app-menu-overlay"
                className="wb-app-menu-drpdwn"
                menu={overlay}>
                <span className="app-menu-button app-contact-menu-button">
                    <WhatsAppOutlined
                        className="app-menu-item-icon"
                        style={{color: "#25D366", height: "30px", width: "30px"}}
                    />
                    <ResponsiveView devices={[Devices.desktop]}>
                        <div>
                            <p className="large-text">רוצים להתייעץ?</p>
                            <p className="small-text">דברו איתנו, זמינים בכל הערוצים</p>
                        </div>
                    </ResponsiveView>
                </span>
            </Dropdown>
        </div>
    );
};

export default ContactMenu;
